import { NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import StrategyRS3 from "components/pages/strategy/RS3";

interface Props {}

const StrategyRS3Page: NextPage<Props> = ({}) => {
  return <StrategyRS3 />;
};
export default StrategyRS3Page;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  let locale = context.locale || context.defaultLocale || "ko";

  return {
    props: {
      ...(await serverSideTranslations(locale, ["strategy"])),
    },
  };
}
